import { getCookie } from "../../../../utils/cookie";
import apiRequest from "../../../../utils/apiClient";
import { renameTranscriptUrl } from "../../../constants";

export const renameUploadTranscript = async (
  transcriptId: number,
  newTitle: string,
  messageStore: any,
): Promise<boolean> => {
  const body = new FormData();
  body.append("transcript_id", transcriptId.toString());
  body.append("title", newTitle);

  try {
    const response = await apiRequest(renameTranscriptUrl, {
      method: "POST",
      mode: "cors",
      body,
      headers: { "X-CSRFToken": getCookie("csrftoken") },
    });
    if (response.status === 401) {
      messageStore.setMessage("Authentication failed. Please log in again.", "error");
      return false;
    }
    const data = await response.json();
    if (response.ok && data.message === "success") return true;
    messageStore.setMessage(`Error renaming transcript: ${data.message || "Unknown error"}`, "error");
    return false;
  } catch (error: any) {
    messageStore.setMessage(`Network error: ${error.message}`, "error");
    return false;
  }
};
